const FETCH_PRODUCT_BASE = "v3/partner/:partnerId/getProductBase";
const ADD_TO_PRODUCT_BASE = "v3/partner/:partnerId/addToProductBase";
const EDIT_PRODUCT = "v3/partner/:partnerId/:sku/editProduct";
const GET_PRODUCT_BY_SKU = "v3/partner/:partnerId/:sku/getProductBySku";
const IMPORT_PRODUCT_BASE = "v3/partner/:partnerId/product-base/import";

export {
  FETCH_PRODUCT_BASE,
  ADD_TO_PRODUCT_BASE,
  EDIT_PRODUCT,
  GET_PRODUCT_BY_SKU,
  IMPORT_PRODUCT_BASE,
};
